export default __webpack_public_path__ + "static/media/20211-open-source-software.7b5689d3.gif";